import { ChartNoAxesGantt } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ChartNoAxesGanttIcon = createLucideIcon(ChartNoAxesGantt);
